import { render, staticRenderFns } from "./StockSlipDefectiveProduct.vue?vue&type=template&id=38152d20&scoped=true"
import script from "./StockSlipDefectiveProduct.vue?vue&type=script&lang=js"
export * from "./StockSlipDefectiveProduct.vue?vue&type=script&lang=js"
import style0 from "./StockSlipDefectiveProduct.vue?vue&type=style&index=0&id=38152d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38152d20",
  null
  
)

export default component.exports